import { render, staticRenderFns } from "./SettingNumber.vue?vue&type=template&id=4c83ba30"
import script from "./SettingNumber.vue?vue&type=script&lang=ts"
export * from "./SettingNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports